import DOMPurify, { type Config } from 'dompurify'

/**
 * The one way to put an HTML string into the DOM (#142).
 *
 * Every `dangerouslySetInnerHTML` in this app renders HTML that someone else
 * wrote: a ticket body typed by another user, a mailer template with receiver
 * values spliced in, a preview the server rendered with customer data. Without
 * this, any of them runs script in the viewer's session.
 *
 * DOMPurify, not a hand-rolled filter: an incomplete allowlist reads as a fix
 * while leaving the hole (see the local one in MailEditor).
 *
 * `FORCE_BODY` keeps a leading `<style>` block — the server-rendered invoice
 * and email previews start with one, and the parser would otherwise move it
 * into a <head> that sanitising discards.
 */
export const SANITIZE_HTML_CONFIG: Config = {
    USE_PROFILES: { html: true },
    FORCE_BODY: true,
}

export function sanitizeHtml(html: string | null | undefined): string {
    if (!html) return ''
    return DOMPurify.sanitize(html, SANITIZE_HTML_CONFIG) as string
}
